import { render, staticRenderFns } from "./activite-type.vue?vue&type=template&id=2dd8ac30&scoped=true&"
import script from "./activite-type.vue?vue&type=script&lang=ts&"
export * from "./activite-type.vue?vue&type=script&lang=ts&"
import style0 from "./activite-type.vue?vue&type=style&index=0&id=2dd8ac30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd8ac30",
  null
  
)

export default component.exports